import { useEffect, useRef } from 'react'

const useListenerClose = (onClose, esc) => {
  const ref = useRef()

  const toggle = (e) => {
    onClose(e)
  }

  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      toggle(e)
    }
  }

  const handleKey = (e) => {
    if (esc && e.key === 'Escape') {
      toggle(e)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    if (esc) {
      document.addEventListener('keydown', handleKey)
    }

    return () => {
      document.removeEventListener('mousedown', handleClick)
      if (esc) {
        document.removeEventListener('keydown', handleKey)
      }
    }
  }, [])

  return { ref, toggle }
}

export default useListenerClose
